import axiosInstance from '../../services/axiosInterceptor'

function call(mode, method, path, body) {
  const url = `/api/notifications${path}`
  if (method === 'get') return axiosInstance.get(url).then(r => r.data)
  if (method === 'patch') return axiosInstance.patch(url, body || {}).then(r => r.data)
  return axiosInstance[method](url, body || {}).then(r => r.data)
}

export const listNotifications = (mode = 'staff', limit = 50) =>
  call(mode, 'get', `/?limit=${limit}`)

export const getUnreadCount = (mode = 'staff') =>
  call(mode, 'get', '/unread-count')

export const markNotificationRead = (mode = 'staff', noti_id) =>
  call(mode, 'patch', `/${noti_id}/read`)

export const markAllNotificationsRead = (mode = 'staff') =>
  call(mode, 'patch', '/read-all')
